import { useState } from 'react';
import { Chip, Dialog, FlexCenter } from '@elementary/common-ui/components';
import { Typography } from '@mui/material';
import { fontWeight } from '@elementary/common-ui/style/utils';
import JiraWebhookSection from './JiraWebhookSection';

type Props = {
  open: boolean;
  onClose: () => void;
  envId: string;
  integrationId: string;
  isInitialSetup?: boolean;
};

const JiraWebhookDialog = ({
  open,
  onClose,
  envId,
  integrationId,
  isInitialSetup,
}: Props) => {
  const [isConfigured, setIsConfigured] = useState<boolean | null>(null);
  const [isError, setIsError] = useState(false);

  const statusChip =
    isConfigured === null ? null : isError ? (
      <Chip label="Error" color="error" />
    ) : isConfigured ? (
      <Chip label="Configured" color="success" />
    ) : (
      <Chip label="Not configured" color="warning" />
    );

  return (
    <Dialog
      open={open}
      onClose={onClose}
      title="Configure Jira Webhook (Optional)"
      message={
        <JiraWebhookSection
          envId={envId}
          integrationId={integrationId}
          onStatusChange={(configured, error) => {
            setIsConfigured(configured);
            setIsError(error);
          }}
        />
      }
      confirmText={isInitialSetup ? 'Skip for now' : 'Close'}
      onConfirmButtonClick={onClose}
      hideCancelButton
      footerMessage={
        statusChip && (
          <FlexCenter gap={1}>
            <Typography sx={{ fontWeight: fontWeight('semibold') }}>
              WebHook status:
            </Typography>
            {statusChip}
          </FlexCenter>
        )
      }
      customWidth={700}
    />
  );
};

export default JiraWebhookDialog;
